module.exports = __webpack_public_path__ + "static/media/Jupyter.411385ce.png";